'use client';

import clsx from 'clsx';
import { H2, P } from '@/components/ui';
import AppLink from '@/components/i18n/AppLink';

export type HomeLeadCtaSectionProps = {
  title: string;
  body: string;
  primaryHref: string;
  primaryLabel: string;
  secondaryHref: string;
  secondaryLabel: string;
  sectionId?: string;
  className?: string;
};

/**
 * Closing CTA band — glass panel, dual actions (consultation + services).
 */
const HomeLeadCtaSection: React.FC<HomeLeadCtaSectionProps> = ({
  title,
  body,
  primaryHref,
  primaryLabel,
  secondaryHref,
  secondaryLabel,
  sectionId,
  className,
}) => {
  return (
    <section
      id={sectionId}
      className={clsx('container-section', className)}
      aria-labelledby="home-lead-cta"
    >
      <div className="page-cta-panel mx-auto max-w-4xl">
        <div className="page-cta-panel__inner text-center">
        <H2 id="home-lead-cta" className="m-0 text-2xl font-semibold tracking-tight text-prose text-balance sm:text-3xl">
          {title}
        </H2>
        <P className="mx-auto mt-4 max-w-2xl leading-relaxed text-prose-muted">{body}</P>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <AppLink href={primaryHref} btn="primary">
            {primaryLabel}
          </AppLink>
          <AppLink
            href={secondaryHref}
            className="text-sm font-medium text-prose-muted underline-offset-4 hover:text-prose hover:underline"
          >
            {secondaryLabel}
          </AppLink>
        </div>
        </div>
      </div>
    </section>
  );
};

export default HomeLeadCtaSection;
